function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    preview\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,31.83A11.83,11.83,0,1,1,31.83,20,11.85,11.85,0,0,1,20,31.83Zm0-21.41A9.58,9.58,0,1,0,29.58,20,9.59,9.59,0,0,0,20,10.42Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 4.59,
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.78,21.07a1.06,1.06,0,0,1-1-1.52C2,19.08,7.27,8.23,20,8.23S38,19.08,38.19,19.55a1.07,1.07,0,1,1-1.93.91c-.2-.42-4.91-10.1-16.26-10.1S3.79,20.35,3.74,20.45A1.06,1.06,0,0,1,2.78,21.07Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20,31.77C7.27,31.77,2,20.92,1.81,20.45a1.06,1.06,0,0,1,1.93-.9C3.94,20,8.65,29.64,20,29.64S36.06,20,36.26,19.55a1.06,1.06,0,0,1,1.93.9C38,20.92,32.73,31.77,20,31.77Z",
  fill: "#231f20"
});

function SvgPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgPreview;